import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { ReplaySubject, Observable, BehaviorSubject } from 'rxjs';
import { BearerToken } from '../models/bearer.token';
import { ApiService, EncryptionService } from '.';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonConstants } from 'src/app/shared/constant';
import {
  IApiResponse,
  IBreadCrumb,
  IChangePasswordDto,
  IForgotPasswordDto,
  ILoginDto,
  IOutletFeaturesDto,
  IRestaurantDto,
  IRestaurantLoginDto,
  IUserDto,
} from '../models';
@Injectable()
export class AuthService {
  private readonly userKey: string = CommonConstants.authorizationKey;

  private isLoggedInSubject = new ReplaySubject<boolean>(1);
  public isLoggedIn = this.isLoggedInSubject.asObservable();

  private isOutletChangeSubject = new ReplaySubject<boolean>(1);
  public isOutletChange = this.isOutletChangeSubject.asObservable();

  private outletFeatureSubject = new BehaviorSubject<IOutletFeaturesDto>(null);
  public outletFeature = this.outletFeatureSubject.asObservable();

  private breadCrumbSubject = new BehaviorSubject<IBreadCrumb[]>(null);
  public breadCrumb = this.breadCrumbSubject.asObservable();

  constructor(
    private readonly tokenService: TokenService,
    private readonly apiService: ApiService,
    private readonly encryptionService: EncryptionService,
    private readonly http: HttpClient
  ) {}

  public onAppLoad() {
    const token = this.tokenService.getToken();
    if (token) {
      this.isLoggedInSubject.next(true);
    } else {
      this.isLoggedInSubject.next(false);
    }
    this.setOutletChange(true);
  }

  public setLoggedIn(value: boolean): void {
    this.isLoggedInSubject.next(value);
  }

  public setOutletChange(value: boolean): void {
    this.isOutletChangeSubject.next(value);
  }

  public setOutletFeatures(value: IOutletFeaturesDto): void {
    this.outletFeatureSubject.next(value);
  }

  public setBreadCrumb(value: any): void {
    this.breadCrumbSubject.next(value);
  }

  public register(model: IUserDto): Observable<IApiResponse<boolean>> {
    return this.apiService.post(`account`, model);
  }

  public getModuleAccess(id: number | string): boolean {
    var token = this.tokenService.getToken();
    if (token.access_key) {
      //const decryptedKey = this.encryptionService.get(token.access_key);
      const access_keys = token.access_key.split(';');
      for (const key of access_keys) {
        if (key.substring(0, 1) == id) {
          const access = key.split(':');
          if (access[1] === '1') {
            return true;
          } else {
            return false;
          }
        }
      }
    }
    return false;
  }

  public updateRestaurant(model: IRestaurantDto, key: string) {
    let token = this.tokenService.getToken();
    token.restaurantId = model.id;
    token.rest_name = model.name;
    token.rest_url = model.webSiteLink;
    token.android_url = model.androidAppLink;
    token.ios_url = model.iosAppLink;
    token.isAndroid = model.showAndroidStore;
    token.isIos = model.showIosStore;
    token.access_key = key;
    this.tokenService.setToken(token, false);
    this.setOutletChange(true);
  }

  public updateOutlet(id: number, name: string) {
    let token = this.tokenService.getToken();
    token.outletId = id;
    token.out_name = name;
    this.tokenService.setToken(token, false);
    this.setOutletChange(true);
  }

  public updateProfileToken(name: string, mobile: string) {
    let token = this.tokenService.getToken();
    token.fullName = name;
    token.mobile = mobile;
    this.tokenService.setToken(token, false);
    this.setLoggedIn(true);
  }

  public updateProfile(model: IUserDto): Observable<IApiResponse<boolean>> {
    return this.apiService.put(`user`, model);
  }

  public changePassword(
    model: IChangePasswordDto
  ): Observable<IApiResponse<boolean>> {
    return this.apiService.post(`account/changePassword`, model);
  }

  public forgotPassword(
    model: IForgotPasswordDto
  ): Observable<IApiResponse<boolean>> {
    return this.apiService.post(`account/forgotPassword`, model);
  }

  public login(credentials: ILoginDto): any {
    const url =
      environment.api_url.substring(
        0,
        environment.api_url.lastIndexOf('/api')
      ) + '/token';

    var data =
      'userName=' +
      credentials.username +
      '&password=' +
      credentials.password +
      '&grant_type=password';
    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/x-www-urlencoded',
      'No-Auth': 'True',
      ClientId: credentials.clientId.toString(),
      RoleId: credentials.roleId.toString(),
      SourceId: credentials.sourceId.toString(),
      OtpLogin: credentials.otpLogin.toString(),
    });
    return this.http.post(url, data, { headers: reqHeader }).pipe(
      map((data: BearerToken) => {
        const token = new BearerToken(data);
        this.tokenService.setToken(token, false);
        this.setLoggedIn(true);
        return data;
      })
    );
  }

  public restaurantLogin(
    model: IRestaurantLoginDto
  ): Observable<IApiResponse<IRestaurantLoginDto>> {
    return this.apiService.post(`account/login`, model);
  }

  public signUp(model: IUserDto): Observable<IApiResponse<boolean>> {
    return this.apiService.post(`account/register`, model);
  }

  public logOut() {
    this.tokenService.removeToken();
    this.setLoggedIn(false);
  }
}
